import { Result, SettingName } from '@standardnotes/domain-core';
export class GetRecoveryCodes {
    constructor(authClient, settingsClient, encryption) {
        this.authClient = authClient;
        this.settingsClient = settingsClient;
        this.encryption = encryption;
    }
    async execute(dto) {
        if (!dto.password) {
            return Result.fail('Password is required to get recovery code.');
        }
        const currentRootKey = await this.encryption.computeRootKey(dto.password, this.encryption.getRootKeyParams());
        const serverPassword = currentRootKey.serverPassword;
        if (!serverPassword) {
            return Result.fail('Could not compute server password');
        }
        const existingRecoveryCodes = await this.settingsClient.getSetting(SettingName.create(SettingName.NAMES.RecoveryCodes).getValue(), serverPassword);
        if (existingRecoveryCodes !== undefined) {
            return Result.ok(existingRecoveryCodes);
        }
        const generatedRecoveryCodes = await this.authClient.generateRecoveryCodes({ serverPassword });
        if (generatedRecoveryCodes === false) {
            return Result.fail('Could not generate recovery code');
        }
        return Result.ok(generatedRecoveryCodes);
    }
}
